import { Component } from '@angular/core';
import { BackgroundColorBlockHtml, BlockHtml, PaddingBlockHtml } from '@src/app/@shared/models/step.model';
import { BlockAbstractComponent } from '@app/components/blocks/block.abstract.component';

@Component({
  selector: 'pl-block-html',
  templateUrl: './block-html.component.html',
})
export class BlockHtmlComponent extends BlockAbstractComponent<BlockHtml, null> {
  protected override initForm(): void {}

  protected override patchFormWithEmptyValue(): void {}

  protected override patchFormFromBlock(block: BlockHtml): void {
    if (block.data.config?.hideIfStepIsCompleted && this.courseContentService.isCurrentStepCompleted()) {
      this.hideBlock();
    }
  }

  protected override getCustomCssClassForBlock(block: BlockHtml): Set<string> {
    const customCssClassesForBlock: Set<string> = super.getCustomCssClassForBlock(block);

    if (block.data.config?.bgColor === BackgroundColorBlockHtml.silver) {
      customCssClassesForBlock.add('bg-pl-gray-250');
    }

    if (block.data.config?.padding === PaddingBlockHtml.noBgPadding) {
      // Adding padding when there is a "noBgPadding" option is not logical
      // But this is a hack to accommodate shitty data coming from the old days (HTML block within container block)
      customCssClassesForBlock.add('pt-4');
      customCssClassesForBlock.add('!pb-0');
    }

    return customCssClassesForBlock;
  }
}
